import { createFilledIcon } from '@ps/ds/icons/helpers/createFilledIcon'

export const HourglassFilled = createFilledIcon(
  'HourglassFilled',
  [
    [
      'path',
      {
        d: 'M18.75 7.09125V3.75C18.75 3.35218 18.592 2.97064 18.3107 2.68934C18.0294 2.40804 17.6478 2.25 17.25 2.25H6.75C6.35218 2.25 5.97064 2.40804 5.68934 2.68934C5.40804 2.97064 5.25 3.35218 5.25 3.75V7.125C5.25051 7.35778 5.30495 7.58727 5.40905 7.79548C5.51315 8.00368 5.66408 8.18493 5.85 8.325L10.7503 12L5.85 15.675C5.66408 15.8151 5.51315 15.9963 5.40905 16.2045C5.30495 16.4127 5.25051 16.6422 5.25 16.875V20.25C5.25 20.6478 5.40804 21.0294 5.68934 21.3107C5.97064 21.592 6.35218 21.75 6.75 21.75H17.25C17.6478 21.75 18.0294 21.592 18.3107 21.3107C18.592 21.0294 18.75 20.6478 18.75 20.25V16.9088C18.7495 16.6769 18.6955 16.4482 18.5922 16.2406C18.489 16.033 18.3393 15.8519 18.1547 15.7116L13.2441 12L18.1547 8.28844C18.3393 8.14807 18.489 7.96703 18.5922 7.7594C18.6955 7.55177 18.7495 7.32313 18.75 7.09125ZM17.25 16.9088V20.25H6.75V16.875L11.25 13.5V15.75C11.25 15.9489 11.329 16.1397 11.4697 16.2803C11.6103 16.421 11.8011 16.5 12 16.5C12.1989 16.5 12.3897 16.421 12.5303 16.2803C12.671 16.1397 12.75 15.9489 12.75 15.75V13.5075L17.25 16.9088ZM17.25 7.09125L16.7091 7.5H7.24969L6.75 7.125V3.75H17.25V7.09125Z',
        stroke: 'none',
        key: 'HourglassFilled-0',
      },
    ],
  ],
  {
    defaultGradient: 'alabaster',
  },
)

HourglassFilled.displayName = 'HourglassFilled'
